export default function BeforeAfter() {
  const cases = [
    {
      gender: '女性',
      age: '60歳',
      treatment: 'インプラント上顎2本',
      price: '88万円(税込)',
      reason: '奥歯で噛めない、前歯がすいてきたので、インプラントを実施。ワイヤー矯正も実施しました。',
      risk: '腫れや疼痛を感じる、違和感を感じるなどの症状を生じることがあります。',
      beforeImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/66de340f6dea7bc2c8c9edef4eae4a8f.jpeg',
      afterImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/80da5435cf01070c56f0e0b4f0671843.jpeg'
    },
    {
      gender: '女性',
      age: '40歳',
      treatment: 'インプラント2本ずつ(計4本)※とばし',
      price: '88万円(税込)',
      reason: '事故で前歯が4本折れてしまい、インプラントを実施',
      risk: '腫れや疼痛を感じる、違和感を感じるなどの症状を生じることがあります。',
      beforeImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/dce59d3768d39df3ac848b149accebaf.jpeg',
      afterImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/bf436a5bdda227683f9bfc7138f75c2c.jpeg'
    },
    {
      gender: '男性',
      age: '60歳',
      treatment: 'AGC(全顎インプラント)治療',
      price: '400万円(税込)',
      reason: '全顎的に歯周病が進行し、食事が取りづらくなってきたため、全顎的なインプラント治療を実施',
      risk: '腫れや疼痛を感じる、違和感を感じるなどの症状を生じることがあります。',
      beforeImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/195b8938c0a7227c6b6d9cd453f1f15e.jpeg',
      afterImage: 'https://static.readdy.ai/image/4d1e24136ef2955fabe2fc9c76951eeb/5e5c52df1416698f83489f76c5edef74.jpeg'
    }
  ];

  return (
    <section id="before-after" className="py-24 bg-gradient-to-b from-slate-50 via-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="text-sm font-bold text-amber-500 tracking-widest uppercase">Before and After</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold mb-6 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Serif JP", serif', letterSpacing: '0.02em' }}>
            ビフォーアフター
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-yellow-500 mx-auto"></div>
        </div>

        <div className="space-y-12">
          {cases.map((caseItem, index) => (
            <div key={index} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-slate-200 hover:shadow-3xl transition-shadow">
              <div className="grid lg:grid-cols-2 gap-10 p-10">
                <div className="space-y-6">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="group">
                      <div className="bg-gradient-to-r from-red-500 to-red-600 text-white text-center py-3 rounded-t-2xl font-bold text-lg shadow-lg">
                        Before
                      </div>
                      <div className="relative overflow-hidden rounded-b-2xl shadow-xl">
                        <img 
                          src={caseItem.beforeImage} 
                          alt="治療前" 
                          className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                    </div>
                    <div className="group">
                      <div className="bg-gradient-to-r from-amber-400 to-yellow-500 text-slate-900 text-center py-3 rounded-t-2xl font-bold text-lg shadow-lg">
                        After
                      </div>
                      <div className="relative overflow-hidden rounded-b-2xl shadow-xl">
                        <img 
                          src={caseItem.afterImage} 
                          alt="治療後" 
                          className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="grid grid-cols-2 gap-6">
                    <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-6 border border-slate-200">
                      <dt className="text-sm font-bold text-slate-600 mb-3 uppercase tracking-wide">性別年齢</dt>
                      <dd className="text-lg text-slate-900 font-semibold">{caseItem.gender}：{caseItem.age}</dd>
                    </div>
                    <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-6 border border-slate-200">
                      <dt className="text-sm font-bold text-slate-600 mb-3 uppercase tracking-wide">治療内容</dt>
                      <dd className="text-lg text-slate-900 font-semibold">{caseItem.treatment}</dd>
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-2xl p-6 border border-amber-200 shadow-lg">
                    <dt className="text-sm font-bold text-amber-700 mb-3 uppercase tracking-wide">金額</dt>
                    <dd className="text-3xl font-bold bg-gradient-to-r from-amber-600 to-yellow-600 bg-clip-text text-transparent" style={{ fontFamily: '"Playfair Display", serif' }}>{caseItem.price}</dd>
                  </div>

                  <div className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-6 border border-slate-200">
                    <dt className="text-sm font-bold text-slate-600 mb-3 uppercase tracking-wide">来院理由</dt>
                    <dd className="text-slate-700 leading-relaxed font-light">{caseItem.reason}</dd>
                  </div>

                  <div className="bg-gradient-to-br from-yellow-50 to-amber-50 border-l-4 border-yellow-500 p-6 rounded-xl shadow-md">
                    <dt className="text-sm font-bold text-slate-900 mb-3 flex items-center">
                      <i className="ri-alert-line text-yellow-600 mr-2 text-lg"></i>
                      施術の副作用(リスク)
                    </dt>
                    <dd className="text-slate-700 text-sm font-light">{caseItem.risk}</dd>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="mailto:yuhmadental@gmail.com?subject=インプラントのお問い合わせ&body=■お名前:%0d%0a■お電話番号:%0d%0a■メールアドレス:%0d%0a■ご相談・お問い合わせ:" 
            className="inline-flex items-center justify-center px-12 py-6 bg-gradient-to-r from-slate-900 to-slate-800 text-white text-lg font-bold rounded-full hover:from-slate-800 hover:to-slate-700 transition-all shadow-2xl hover:shadow-slate-900/50 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-mail-line mr-3 text-xl"></i>
            メールでのお問い合わせはこちら
            <i className="ri-arrow-right-line ml-3 text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}